class doctorListController {
	$onInit() {
		if(!this.doctorList)this.doctorList=[];
	}
}

export default doctorListController;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-list/doctor-list.controller.js